module.exports = __webpack_public_path__ + "img/nothing.98907b96.png";